import { motion } from 'motion/react';
import { useSelector } from 'react-redux';
import { getInitials } from 'src/store/auth';

export const UserAvatar = () => {
  const initials = useSelector(getInitials);
  return (
    <motion.div
      className="w-8 h-8 rounded-full bg-cyan-400 flex items-center justify-center text-background-dark-default font-medium text-md flex-shrink-0"
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.4 }}
    >
      {/* substitute by user initials */}
      {initials ?? 'User'}
    </motion.div>
  );
};
